"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolInfo = void 0;
/**
 *
 *
 */
class SymbolInfo {
    _LineInfo;
    _TextInfo;
    constructor(...args) {
        switch (args.length) {
            case 0: {
                break;
            }
            case 2: {
                const [ti, li] = args;
                this._LineInfo = li;
                this._TextInfo = ti;
                break;
            }
            default: {
                throw Error(`Invalid number of arguments`);
            }
        }
    }
    getTextInfoList() {
        return this._TextInfo;
    }
    getLineInfoList() {
        return this._LineInfo;
    }
}
exports.SymbolInfo = SymbolInfo;
//# sourceMappingURL=SymbolInfo.js.map